import DevicesIcon from "@mui/icons-material/Devices"
import DeviceCreate from "./create"
import DeviceEdit from "./edit"
import DeviceList from "./list"
import DeviceShow from "./show"
import Chart from "./chart.ddt"
import Data from "./data.ddt"
import Listddt from "./list.ddt"
import Schedule from "./schedule.list"
import ScheduleCreate from "./schedule.create"
import ScheduleEdit from "./schedule.edit"
import DeviceAuditHistoryPage from "./audit"


const options = {
    list: DeviceList,
    create: DeviceCreate,
    edit: DeviceEdit,
    show: DeviceShow,
    icon: DevicesIcon,
    audit: DeviceAuditHistoryPage,
    chart: Chart,
    data: Data,
    listddt: Listddt,
    schedules: Schedule,
    schedulecreate: ScheduleCreate,
    scheduleedit: ScheduleEdit,
    //recordRepresentation: (record: any)=> `${record.name} (${record.role})`,
}

export default options

export interface Device {
  id: string;
  imei: string;
  name: string;
  description?: string;
  object_name?: string;
  created_at: string;
  updated_at?: string;
}
